// extracted by mini-css-extract-plugin
export default {"CalendarWidget":"CalendarWidget_CalendarWidget__9KNDc","month":"CalendarWidget_month__IIYWq","dayOfMonth":"CalendarWidget_dayOfMonth__IFrYI"};